import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Anaheim",
    route: "/cities/anaheim",
    tagline: "Orange County expedited passport services near Disneyland and convention centers",
    highlights: ["Orange County coverage", "Serving Santa Ana, Fullerton, Garden Grove"],
    badge: null,
    status: "live",
  },
  {
    name: "Antioch",
    route: "/cities/antioch",
    tagline: "Contra Costa County expedited passport services for East Bay travelers near the Sacramento-San Joaquin River Delta",
    highlights: ["East Bay coverage", "Serving Pittsburg, Brentwood, Oakley, Concord, Martinez"],
    badge: null,
    status: "live",
  },
  {
    name: "Bakersfield",
    route: "/cities/bakersfield",
    tagline: "Kern County trusted passport processing for Central Valley travelers",
    highlights: ["Kern County coverage", "Serving Delano, Visalia, Porterville"],
    badge: null,
    status: "live",
  },
  {
    name: "Berkeley",
    route: "/cities/berkeley",
    tagline: "Alameda County expedited passport services for East Bay travelers near UC Berkeley",
    highlights: ["East Bay coverage", "Serving Oakland, Richmond, Emeryville, El Cerrito"],
    badge: null,
    status: "live",
  },
  {
    name: "Burbank",
    route: "/cities/burbank",
    tagline: "Los Angeles County passport services near Hollywood Burbank Airport and media district",
    highlights: ["San Fernando Valley coverage", "Serving Glendale, Pasadena, Studio City"],
    badge: null,
    status: "live",
  },
  {
    name: "Carlsbad",
    route: "/cities/carlsbad",
    tagline: "North San Diego County coastal expedited passport processing near Legoland",
    highlights: ["San Diego North County coverage", "Serving Oceanside, Vista, Encinitas, San Marcos"],
    badge: null,
    status: "live",
  },
  {
    name: "Chula Vista",
    route: "/cities/chula-vista",
    tagline: "South Bay San Diego expedited passport services near Mexico border",
    highlights: ["South Bay coverage", "Serving National City, Imperial Beach, Bonita"],
    badge: null,
    status: "live",
  },
  {
    name: "Compton",
    route: "/cities/compton",
    tagline: "South Bay Los Angeles expedited passport services for Gateway Cities travelers near the Port of Long Beach",
    highlights: ["South Bay coverage", "Serving Lynwood, Paramount, South Gate, Carson, Long Beach"],
    badge: null,
    status: "live",
  },
  {
    name: "Costa Mesa",
    route: "/cities/costa-mesa",
    tagline: "Central Orange County expedited passport services near South Coast Plaza",
    highlights: ["Central OC coverage", "Serving Newport Beach, Irvine, Huntington Beach"],
    badge: null,
    status: "live",
  },
  {
    name: "Daly City",
    route: "/cities/daly-city",
    tagline: "San Mateo County expedited passport services on the San Francisco Peninsula",
    highlights: ["Peninsula coverage", "Serving South San Francisco, San Bruno, Pacifica, Millbrae"],
    badge: null,
    status: "live",
  },
  {
    name: "Escondido",
    route: "/cities/escondido",
    tagline: "North San Diego County expedited passport processing for inland and coastal communities",
    highlights: ["Inland North County coverage", "Serving San Marcos, Vista, Poway, Oceanside"],
    badge: null,
    status: "live",
  },
  {
    name: "Fullerton",
    route: "/cities/fullerton",
    tagline: "North Orange County expedited passport services near Cal State Fullerton",
    highlights: ["North OC coverage", "Serving Anaheim, Brea, La Habra, Placentia"],
    badge: null,
    status: "live",
  },
  {
    name: "Fresno",
    route: "/cities/fresno",
    tagline: "Central Valley's expedited passport hub for Clovis and Madera travelers",
    highlights: ["Fresno County coverage", "Serving Clovis, Madera, Hanford"],
    badge: null,
    status: "live",
  },
  {
    name: "Garden Grove",
    route: "/cities/garden-grove",
    tagline: "Central Orange County expedited passport services near Little Saigon",
    highlights: ["Central OC coverage", "Serving Anaheim, Santa Ana, Westminster, Fountain Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Glendale",
    route: "/cities/glendale",
    tagline: "Los Angeles County expedited passport services near Brand Boulevard and Americana",
    highlights: ["San Fernando Valley coverage", "Serving Burbank, La Cañada, La Crescenta"],
    badge: null,
    status: "live",
  },
  {
    name: "Hayward",
    route: "/cities/hayward",
    tagline: "Alameda County expedited passport processing for East Bay travelers near San Francisco",
    highlights: ["East Bay coverage", "Serving San Leandro, Castro Valley, Union City, Fremont"],
    badge: null,
    status: "live",
  },
  {
    name: "Huntington Beach",
    route: "/cities/huntington-beach",
    tagline: "Orange County coastal expedited passport services near Surf City USA",
    highlights: ["North OC coast coverage", "Serving Fountain Valley, Westminster, Seal Beach"],
    badge: null,
    status: "live",
  },
  {
    name: "Irvine",
    route: "/cities/irvine",
    tagline: "Orange County expedited passport services near Irvine Business Complex",
    highlights: ["Central Orange County coverage", "Serving Tustin, Lake Forest, Mission Viejo"],
    badge: null,
    status: "live",
  },
  {
    name: "Long Beach",
    route: "/cities/long-beach",
    tagline: "Los Angeles County coastal expedited passport processing near the port",
    highlights: ["South Bay coverage", "Serving Signal Hill, Lakewood, Carson"],
    badge: null,
    status: "live",
  },
  {
    name: "Los Angeles",
    route: "/cities/los-angeles",
    tagline: "Southern California's largest expedited passport service hub",
    highlights: ["LA County wide coverage", "Serving Hollywood, Downtown, Westside"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Modesto",
    route: "/cities/modesto",
    tagline: "Stanislaus County expedited passport services for Central Valley travelers",
    highlights: ["Stanislaus County coverage", "Serving Turlock, Ceres, Manteca"],
    badge: null,
    status: "live",
  },
  {
    name: "Menifee",
    route: "/cities/menifee",
    tagline: "Riverside County expedited passport services for Inland Empire travelers near Temecula and Murrieta",
    highlights: ["Inland Empire coverage", "Serving Murrieta, Temecula, Hemet, Lake Elsinore, Perris, Wildomar"],
    badge: null,
    status: "live",
  },
  {
    name: "Moreno Valley",
    route: "/cities/moreno-valley",
    tagline: "Riverside County expedited passport processing for Inland Empire near Box Springs Mountain",
    highlights: ["Inland Empire coverage", "Serving Riverside, Perris, Hemet, Redlands, San Bernardino"],
    badge: null,
    status: "live",
  },
  {
    name: "Newport Beach",
    route: "/cities/newport-beach",
    tagline: "Coastal Orange County expedited passport services near Balboa Peninsula",
    highlights: ["Coastal OC coverage", "Serving Costa Mesa, Laguna Beach, Corona del Mar"],
    badge: null,
    status: "live",
  },
  {
    name: "Redding",
    route: "/cities/redding",
    tagline: "Shasta County expedited passport services for North State travelers near the Sundial Bridge and Mount Shasta",
    highlights: ["North State coverage", "Serving Shasta Lake, Anderson, Red Bluff, Chico, Mount Shasta"],
    badge: null,
    status: "live",
  },
  {
    name: "Merced",
    route: "/cities/merced",
    tagline: "Merced County expedited passport services for Central Valley travelers near UC Merced and Yosemite gateway",
    highlights: ["Central Valley coverage", "Serving Atwater, Livingston, Turlock, Chowchilla, Los Banos"],
    badge: null,
    status: "live",
  },
  {
    name: "Tustin",
    route: "/cities/tustin",
    tagline: "Orange County expedited passport services in historic Tustin near Old Town and the Irvine border",
    highlights: ["Central Orange County coverage", "Serving Irvine, Santa Ana, Orange, Anaheim, Costa Mesa"],
    badge: null,
    status: "live",
  },
  {
    name: "Vacaville",
    route: "/cities/vacaville",
    tagline: "Solano County expedited passport services for the Sacramento Valley near Travis Air Force Base",
    highlights: ["Solano County coverage", "Serving Fairfield, Dixon, Suisun City, Benicia, Napa"],
    badge: null,
    status: "live",
  },
  {
    name: "Mountain View",
    route: "/cities/mountain-view",
    tagline: "Santa Clara County expedited passport services in the heart of Silicon Valley near Google and Shoreline",
    highlights: ["Silicon Valley coverage", "Serving Sunnyvale, Palo Alto, Los Altos, Cupertino, Menlo Park"],
    badge: null,
    status: "live",
  },
  {
    name: "San Mateo",
    route: "/cities/san-mateo",
    tagline: "San Mateo County expedited passport services on the Peninsula near Burlingame and SFO",
    highlights: ["Peninsula coverage", "Serving Burlingame, Foster City, Belmont, San Carlos, Redwood City"],
    badge: null,
    status: "live",
  },
  {
    name: "Livermore",
    route: "/cities/livermore",
    tagline: "Alameda County expedited passport services in the Tri-Valley wine country near Pleasanton and Dublin",
    highlights: ["Tri-Valley coverage", "Serving Pleasanton, Dublin, San Ramon, Danville, Tracy"],
    badge: null,
    status: "live",
  },
  {
    name: "Tracy",
    route: "/cities/tracy",
    tagline: "San Joaquin County expedited passport services in the Central Valley near Manteca and Stockton",
    highlights: ["San Joaquin County coverage", "Serving Manteca, Lathrop, Stockton, Lodi, Modesto"],
    badge: null,
    status: "live",
  },
  {
    name: "Oakland",
    route: "/cities/oakland",
    tagline: "Alameda County expedited passport hub for East Bay travelers",
    highlights: ["East Bay coverage", "Serving Berkeley, Emeryville, Alameda"],
    badge: null,
    status: "live",
  },
  {
    name: "Concord",
    route: "/cities/concord",
    tagline: "Contra Costa County expedited passport services in the East Bay near Walnut Creek and Mount Diablo",
    highlights: ["East Bay coverage", "Serving Walnut Creek, Pleasant Hill, Martinez, Lafayette"],
    badge: null,
    status: "live",
  },
  {
    name: "El Cajon",
    route: "/cities/el-cajon",
    tagline: "East San Diego County expedited passport processing in the inland valley near La Mesa and Santee",
    highlights: ["East San Diego County coverage", "Serving La Mesa, Santee, Spring Valley, Lakeside"],
    badge: null,
    status: "live",
  },
  {
    name: "Oceanside",
    route: "/cities/oceanside",
    tagline: "North San Diego County coastal expedited passport services near Camp Pendleton and the pier",
    highlights: ["North San Diego County coverage", "Serving Carlsbad, Vista, San Marcos, Encinitas, Camp Pendleton"],
    badge: null,
    status: "live",
  },
  {
    name: "Roseville",
    route: "/cities/roseville",
    tagline: "Placer County expedited passport services in the Sacramento metro near Rocklin and Folsom",
    highlights: ["Sacramento metro coverage", "Serving Rocklin, Lincoln, Folsom, Citrus Heights, Granite Bay"],
    badge: null,
    status: "live",
  },
  {
    name: "Ontario",
    route: "/cities/ontario",
    tagline: "San Bernardino County expedited passport processing near Ontario International Airport",
    highlights: ["Inland Empire coverage", "Serving Rancho Cucamonga, Upland, Claremont"],
    badge: null,
    status: "live",
  },
  {
    name: "Orange",
    route: "/cities/orange",
    tagline: "North Orange County expedited passport services near the historic plaza",
    highlights: ["North OC coverage", "Serving Anaheim, Villa Park, Tustin"],
    badge: null,
    status: "live",
  },
  {
    name: "Oxnard",
    route: "/cities/oxnard",
    tagline: "Ventura County coastal expedited passport services near Channel Islands Harbor",
    highlights: ["Ventura County coverage", "Serving Ventura, Camarillo, Port Hueneme, Thousand Oaks"],
    badge: null,
    status: "live",
  },
  {
    name: "Pasadena",
    route: "/cities/pasadena",
    tagline: "Los Angeles County expedited passport services in the San Gabriel Valley",
    highlights: ["San Gabriel Valley coverage", "Serving Altadena, South Pasadena, San Marino"],
    badge: null,
    status: "live",
  },
  {
    name: "Pomona",
    route: "/cities/pomona",
    tagline: "Los Angeles County expedited passport processing in the Pomona Valley near Cal Poly",
    highlights: ["Eastern LA County coverage", "Serving Claremont, Diamond Bar, Chino, La Verne"],
    badge: null,
    status: "live",
  },
  {
    name: "Rancho Cucamonga",
    route: "/cities/rancho-cucamonga",
    tagline: "San Bernardino County expedited passport services near Victoria Gardens in the Inland Empire",
    highlights: ["Inland Empire coverage", "Serving Fontana, Upland, Ontario, Claremont"],
    badge: null,
    status: "live",
  },
  {
    name: "Rialto",
    route: "/cities/rialto",
    tagline: "San Bernardino County expedited passport services for Inland Empire travelers near the historic Route 66",
    highlights: ["Inland Empire coverage", "Serving San Bernardino, Fontana, Colton, Highland, Redlands"],
    badge: null,
    status: "live",
  },
  {
    name: "Riverside",
    route: "/cities/riverside",
    tagline: "Riverside County expedited passport hub for Inland Empire travelers",
    highlights: ["Inland Empire coverage", "Serving Moreno Valley, Corona, Jurupa Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Sacramento",
    route: "/cities/sacramento",
    tagline: "Northern California capital region expedited passport services",
    highlights: ["Sacramento County coverage", "Serving Elk Grove, Roseville, Folsom"],
    badge: null,
    status: "live",
  },
  {
    name: "Salinas",
    route: "/cities/salinas",
    tagline: "Monterey County expedited passport processing for Central Coast Steinbeck Country travelers",
    highlights: ["Monterey County coverage", "Serving Monterey, Seaside, Marina, Watsonville, Santa Cruz"],
    badge: null,
    status: "live",
  },
  {
    name: "San Bernardino",
    route: "/cities/san-bernardino",
    tagline: "San Bernardino County expedited passport services for Inland Empire",
    highlights: ["Inland Empire coverage", "Serving Rialto, Colton, Highland"],
    badge: null,
    status: "live",
  },
  {
    name: "San Diego",
    route: "/cities/san-diego",
    tagline: "Southern California coastal expedited passport hub near Mexico border",
    highlights: ["San Diego County wide coverage", "Serving Chula Vista, La Jolla, Del Mar"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "San Francisco",
    route: "/cities/san-francisco",
    tagline: "Bay Area expedited passport services for Northern California travelers",
    highlights: ["San Francisco County coverage", "Serving Daly City, South San Francisco, Marin"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "San Jose",
    route: "/cities/san-jose",
    tagline: "Santa Clara County expedited passport hub in the heart of Silicon Valley",
    highlights: ["Silicon Valley coverage", "Serving Santa Clara, Milpitas, Cupertino"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "Santa Ana",
    route: "/cities/santa-ana",
    tagline: "Orange County seat expedited passport processing near downtown civic center",
    highlights: ["Central Orange County coverage", "Serving Tustin, Orange, Fountain Valley"],
    badge: null,
    status: "live",
  },
  {
    name: "Santa Barbara",
    route: "/cities/santa-barbara",
    tagline: "Santa Barbara County expedited passport services on the American Riviera",
    highlights: ["South Coast coverage", "Serving Goleta, Carpinteria, Montecito"],
    badge: null,
    status: "live",
  },
  {
    name: "Santa Clara",
    route: "/cities/santa-clara",
    tagline: "Santa Clara County expedited passport processing in Silicon Valley near Levi's Stadium",
    highlights: ["Silicon Valley coverage", "Serving Sunnyvale, San Jose, Cupertino, Mountain View"],
    badge: null,
    status: "live",
  },
  {
    name: "Santa Monica",
    route: "/cities/santa-monica",
    tagline: "West Los Angeles coastal expedited passport services near the pier",
    highlights: ["Westside coverage", "Serving Brentwood, Venice, Pacific Palisades"],
    badge: null,
    status: "live",
  },
  {
    name: "Santa Rosa",
    route: "/cities/santa-rosa",
    tagline: "Sonoma County expedited passport processing for Wine Country and Russian River travelers",
    highlights: ["Sonoma County coverage", "Serving Petaluma, Rohnert Park, Windsor, Healdsburg, Napa"],
    badge: null,
    status: "live",
  },
  {
    name: "Simi Valley",
    route: "/cities/simi-valley",
    tagline: "Ventura County expedited passport services in the San Fernando Valley corridor near Santa Susana",
    highlights: ["Ventura County coverage", "Serving Thousand Oaks, Moorpark, Westlake Village, Chatsworth"],
    badge: null,
    status: "live",
  },
  {
    name: "Stockton",
    route: "/cities/stockton",
    tagline: "San Joaquin County expedited passport hub for Central Valley travelers",
    highlights: ["San Joaquin County coverage", "Serving Lodi, Tracy, Manteca"],
    badge: null,
    status: "live",
  },
  {
    name: "Sunnyvale",
    route: "/cities/sunnyvale",
    tagline: "Santa Clara County expedited passport processing in Silicon Valley near Moffett Field",
    highlights: ["Silicon Valley coverage", "Serving Mountain View, Cupertino, Palo Alto, San Jose"],
    badge: null,
    status: "live",
  },
  {
    name: "Thousand Oaks",
    route: "/cities/thousand-oaks",
    tagline: "Ventura County expedited passport services in the Conejo Valley",
    highlights: ["Conejo Valley coverage", "Serving Westlake Village, Agoura Hills, Oak Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Torrance",
    route: "/cities/torrance",
    tagline: "South Bay Los Angeles expedited passport processing near the beach",
    highlights: ["South Bay coverage", "Serving Redondo Beach, Hermosa Beach, Palos Verdes"],
    badge: null,
    status: "live",
  },
  {
    name: "Vallejo",
    route: "/cities/vallejo",
    tagline: "Solano County expedited passport services for North Bay travelers near San Pablo Bay",
    highlights: ["North Bay coverage", "Serving Fairfield, Vacaville, Benicia, Napa, American Canyon"],
    badge: null,
    status: "live",
  },
  {
    name: "Ventura",
    route: "/cities/ventura",
    tagline: "Ventura County expedited passport services on the California coast",
    highlights: ["Ventura County coverage", "Serving Oxnard, Camarillo, Ojai"],
    badge: null,
    status: "live",
  },
  {
    name: "Visalia",
    route: "/cities/visalia",
    tagline: "Tulare County expedited passport processing for Central Valley travelers near Sequoia National Park",
    highlights: ["Tulare County coverage", "Serving Tulare, Porterville, Exeter, Hanford"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function CaliforniaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            California Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your California Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">&ldquo;{searchQuery}&rdquo;</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">California</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We are always adding new California locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}